export const triggerAuthUpdate = () => {
    window.dispatchEvent(new CustomEvent('authStateUpdate'));
}; 